import { Navigate, Route } from 'react-router-dom';
import OwOwnerLogin from '../../restaurant/login/Login';
import OwOwnerSettings from '../../restaurant/settings/Settings';
import OwOwnerPaymentResult from '../../restaurant/payment-result/PaymentResult';
import { useAuth } from '../../context/AuthContext';
import RequireAuth from './RequireAuth';
import RestaurantLayout from './layout';

const RestaurantIndex = () => {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? '/restaurant/settings' : '/restaurant/login'} replace />;
};

const GuestOnly = () => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <Navigate to="/restaurant/settings" replace />;
  return <OwOwnerLogin />;
};

export const restaurantRoutes = (
  <Route path="restaurant" element={<RestaurantLayout />}>
    <Route index element={<RestaurantIndex />} />
    <Route path="login" element={<GuestOnly />} />
    <Route path="payment-result" element={<OwOwnerPaymentResult />} />
  </Route>
);

// Settings is a full-page panel (own sidebar), rendered without the site header/footer.
export const restaurantPanelRoutes = (
  <Route path="restaurant" element={<RequireAuth />}>
    <Route path="settings" element={<OwOwnerSettings />} />
  </Route>
);
